import  { memo } from 'react';
import '../style.css';
import { useTranslation } from 'react-i18next';

const PopupBase = ({ name, title , large, onClose, children }) => {

    const { t } = useTranslation()

    return (
        <div className={`modal fade popup`} id={name} tabIndex="-1" role="dialog" aria-hidden='true' 
        onClick={onClose}
        >
            <div className={`modal-dialog modal-dialog ${large ? "modal-xl" : ""}`} role="document">
                <div className="modal-content"
                 onClick={e => e.stopPropagation()}
                 >
                    <div className="modal-body">
                        <div className='popup-title'>{t(title)}</div>
                        <div className='popup-content'>
                        {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default memo(PopupBase);